export default __webpack_public_path__ + "static/media/kdabra-light.373b9648.svg";